import React from "react";
import InnerBanner from "../../components/InnerBanner";
import JobList from "../../components/JobList";
import WorkWithUs from "../../components/WorkWithUs";

const Careers = () => {
  return (
    <>
      <InnerBanner title="Careers"/>
      <WorkWithUs/>
      <JobList/>
    </>
  );
};

export default Careers;
